import { type FeatureModule } from '@/components/routing';

/**
 * Routes of the `access` feature: where the backend sends the browser when Servo refuses or fails to sign it in.
 * Mounted outside the app shell (see `src/router.tsx`), so it is not part of `featureModules`.
 */
export const accessFeature: FeatureModule = {
  id: 'access',
  routes: [
    {
      path: 'no-access',
      lazy: async () => ({ Component: (await import('./pages/no-access-page')).NoAccessPage }),
    },
  ],
};
